import { Language } from './language';

const fr = {
    code: Language.fr,

	// HOME PAGE
	
	t_description: 'Fille batteuse de {age} ans',
	t_close: 'Fermer',

	b_home: 'Accueil',
	b_about: 'Sur moi',
	b_press: 'Presse',
	b_shows: 'Performances en direct',
	b_soultone: 'Soultone',
	b_collision: 'Collision',
	b_language: 'Français',
	b_share: 'Partager',
	b_scroll_to_top: 'Faites défiler vers le haut',
	b_click: 'Cliquez',
	b_tap: 'Appuyer',
	
	t_english: 'Anglaise',
	t_spanish: 'Espagnole',
	t_portuguese: 'Portugais',
	t_italian: 'Italien',
	t_french: 'Français',
	t_german: 'Allemand',
	t_chinese: 'Chinois',

	// SHOWS PAGE

	ClassicMetal_title: 'Métal classique',
	ClassicMetal_description: 'School of Rock Seattle',

	StAlsGrandDay2024_title: 'Performance du Grand Jour 2024',
	StAlsGrandDay2024_description: 'St. Alphonsus Parish School Seattle',

	BlackViolinConcert_title: 'Concert De Violon Noir Avec Le Monde Votre Orchestre',
	BlackViolinConcert_description: 'Le Théâtre Paramount',

	MexicanIndependenceDay2024_title: 'Célébration du Jour de l\'Indépendance du Mexique avec le Ballard Civic Orchestra',
	MexicanIndependenceDay2024_description: 'Hôtel de ville de Seattle',

	BluesRock_title: 'Blues Rock',
	BluesRock_description: 'School of Rock Seattle',

	BallardSeaFoodFest2024_title: 'Festival des fruits de mer Ballard 2024',
	BallardSeaFoodFest2024_description: 'Festival des fruits de mer Ballard',

	Funk_title: 'Funk',
	Funk_description: 'School of Rock Seattle',

	Heart_title: 'Heart',
	Heart_description: 'School of Rock Seattle',
	
	ModernMetal_title: 'Métal moderne',
	ModernMetal_description: 'School of Rock Seattle',

	SeasonPreviewWinter2023_title: 'Aperçu de la saison hiver 2023',
	SeasonPreviewWinter2023_description: 'School of Rock Seattle',

	SmashingPumpkins_title: 'Smashing Pumpkins',
	SmashingPumpkins_description: 'School of Rock Seattle',

	Nirvana_title: 'Nirvana',
	Nirvana_description: 'School of Rock Seattle',

	HairMetal_title: 'Cheveux Métal',
	HairMetal_description: 'School of Rock Seattle',

	TalentShow2023_title: 'Spectacle de talents 2023',
	TalentShow2023_description: 'Seattle Salmon Bay K-8',

	Deftones_title: 'Deftones',
	Deftones_description: 'School of Rock Seattle',

	SeasonPreviewSpring2023_title: 'Aperçu de la saison printemps 2023',
	SeasonPreviewSpring2023_description: 'School of Rock Seattle',

	Ramones_title: 'Les Ramones',
	Ramones_description: 'School of Rock Seattle',

	Soundtrack_title: 'Spectacle de la bande originale',
	Soundtrack_description: 'School of Rock Seattle',

	PopPunkVsEmo_title: 'Pop Punk Vs. Emo',
	PopPunkVsEmo_description: 'School of Rock Seattle',

	_90sNostalgia_title: 'Nostalgie des années 90',
	_90sNostalgia_description: 'School of Rock Seattle',

	TalentShow2022_title: 'Spectacle de talents 2022',
	TalentShow2022_description: 'Seattle Salmon Bay K-8',

	// PRESS PAGE

	b_watch_here: 'Regardez ici',

	fox_13_news_title: 'Fox 13 Seattle News avec',
	fox_13_news_description: 'Section True Northwest avec',

	the_daly_migs_show_interview_title: 'L\'interview du Daly Migs Show',
	the_daly_migs_show_interview_description: 'Interview sur le fait d\'être invité à rejoindre Godsmack sur scène',

	alizee_defan_07_02_2024_title: 'Entretien avec "Alizée Defan"',
	alizee_defan_07_02_2024_description: 'Interview exclusive',

	jaime_mendez_news_06_26_2024_title: 'Interview "Jaime Mendez Nouvelles"',
	jaime_mendez_news_06_26_2024_description: 'Nouvelles locales de Seattle en espagnol',

	bien_informado_03_22_2023_title: 'Article de "Bien Informado"',
	bien_informado_03_22_2023_description: 'Article du site d\'information argentin sur Victoria',

	wave_potter_reaction_01_30_2023_title: 'La réaction de Wave Potter',
	wave_potter_reaction_01_30_2023_description: 'Wave Potter réagit à la reprise de Victoria Lux Æterna de Metallica',

	// ABOUT PAGE

	b_back: 'Retourner',

	t_title: 'Victoria Acosta',
	t_pronouns: '(elle)',

	b_read_more: 'En savoir plus',
	b_read_less: 'Lire moins',

	t_about: `
Avec ses baguettes en main et le rythme dans la peau, Victoria Acosta, {age} ans, captive le public comme l’une des jeunes batteuses les plus prometteuses de sa génération.

Née à El Paso, au Texas, et ayant grandi à Guadalajara, au Mexique, Victoria vit aujourd’hui à Seattle, où elle continue d’impressionner par son dévouement exceptionnel à son art.

Sa passion pour la batterie a commencé à l’âge de quatre ans. Lorsqu’elle a reçu sa première batterie le 13 septembre 2018, tout a changé. Elle a débuté sa formation musicale à l’académie Musicalerias de Guadalajara, puis a poursuivi ses études à Seattle, progressant rapidement. Après une leçon d’essai remarquable à la School of Rock le 29 mai 2022, elle a été directement intégrée au Performers Program, contournant le programme pour débutants. Depuis, Victoria a ébloui le public lors de {shows} concerts live grâce à son énergie contagieuse et sa présence scénique remarquable.

Mais le parcours musical de Victoria ne s’arrête pas là. Elle a enregistré des centaines de vidéos sur les réseaux sociaux, rassemblant une communauté de fans fidèles. Le 13 juin 2024, elle a été invitée en tant que batteuse invitée par le compositeur italien Alberto Rigonni sur l’album Nemesis Call. La même année, elle a signé un partenariat avec Soultone Cymbals le 12 septembre, puis a rejoint les artistes Collision Drumsticks le 8 mars 2025—affirmant ainsi encore davantage sa place parmi les batteurs de la nouvelle génération.

Victoria ne se limite pas à la batterie : elle a aussi commencé le violon en classe de CM1. En 2024, elle a intégré le World Youth Orchestra, a partagé la scène avec le duo Black Violin au Paramount Theatre, et a fait ses débuts comme percussionniste avec le Ballard Civic Orchestra au Town Hall de Seattle, lors d’une célébration de la fête de l’indépendance du Mexique.

Parmi ses nombreuses distinctions figurent le Gold Prize et le Fantastic Technique Award du concours London Young Musician 2022, ainsi que les Annual Star Musician Award et Outstanding Drummer Special Award en 2023.

Victoria s'entraîne quotidiennement, repoussant ses limites à la batterie comme au violon. Avec sa passion inébranlable et sa créativité sans bornes, elle n’est pas seulement une étoile montante—elle est une force de la nature en devenir.
`,

	// PRESS PAGE

	t_footer: 'Tous droits réservés',

		// SOULTONE: 

		b_visit_artist_page: 'Visitez ma page d\'artiste'

}

export default fr;
